import { LOCALE } from '../config'

export default {
  name: LOCALE['zh-tw'],
  plus: {
    table: {
      operate: '操作'
    }
  }
}
